import { ResultListPagination } from "./";

interface CreateColumnCssOptions {}

interface ResultTableProps<T extends unknown> {
  currentPage: number;
  dataSource: T[];
  totalCount: number;
  totalPages: number;
  renderHead: (rowProps: typeof headRowProps) => JSX.Element;
  renderBody: (dataSource: T[], rowProps: typeof bodyRowProps) => JSX.Element;
  renderEmpty: () => JSX.Element;
}

const headRowProps = {
  className: "d-none d-md-table-row text-nowrap",
};

const bodyRowProps = {
  className: "d-flex flex-column d-md-table-row",
};

export const ResultTable = <T extends unknown>({
  currentPage,
  totalCount,
  totalPages,
  dataSource,
  renderHead,
  renderBody,
  renderEmpty,
}: ResultTableProps<T>): JSX.Element => {
  if (totalCount > 0) {
    return (
      <>
        <div className="table-responsive">
          <table
            className="table border-bottom"
            css={`
              > tbody td:not(:first-child) {
                @media (max-width: ${(p): string => p.theme.mdBreakpoint}) {
                  border-top: 0 !important;
                  padding-top: 0 !important;

                  &:not(:last-child) {
                    padding-bottom: 0 !important;
                  }
                }
              }

              > tbody td:first-child {
                @media (max-width: ${(p): string => p.theme.mdBreakpoint}) {
                  // border-top: 0 !important;
                  padding-bottom: 0 !important;
                }
              }
            `}
          >
            {renderHead(headRowProps)}
            {renderBody(dataSource, bodyRowProps)}
          </table>
        </div>
        <ResultListPagination
          currentPage={currentPage}
          totalPages={totalPages}
        />
      </>
    );
  }

  return renderEmpty();
};
